// extracted by mini-css-extract-plugin
export var baseButton = "_wj-0";
export var controlsArrowKeys = "_wj-1";
export var controlsResetButton = "_wj-2";
export var lightGameButton = "_wj-4 _wj-0";
export var playAgainButton = "_wj-5 _wj-0";
export var startGameButton = "_wj-3 _wj-0";